import React from 'react';
import { Section } from './ui/Section';
export function SystemBreakdown() {
  return <Section data-id="element-154">
      <div className="text-center mb-20" data-id="element-155">
        <h2 className="font-serif text-4xl md:text-6xl mb-6 text-white" data-id="element-156">
          The 3-Pillar <br data-id="element-157" />
          <span className="text-luxury-gold italic" data-id="element-158">
            Monetization Structure
          </span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-159">
        {[{
        title: 'Identity Authority',
        desc: 'How to position your presence so people respect your brand instead of scrolling past it.'
      }, {
        title: 'Structured Growth',
        desc: 'The repeatable workflow that removes guesswork and eliminates burnout.'
      }, {
        title: 'Monetization Alignment',
        desc: 'How visibility becomes income when positioning is correct — without chasing clients.'
      }].map((pillar, i) => <div key={i} className="group p-10 border border-white/10 hover:border-luxury-gold/50 transition-all duration-500 bg-luxury-charcoal/20" data-id="element-160">
            <span className="block text-6xl font-serif text-luxury-gold/20 mb-6 group-hover:text-luxury-gold/40 transition-colors" data-id="element-161">
              0{i + 1}
            </span>
            <h3 className="font-serif text-2xl mb-4 text-white" data-id="element-162">
              {pillar.title}
            </h3>
            <p className="text-luxury-gray font-light leading-relaxed" data-id="element-163">
              {pillar.desc}
            </p>
          </div>)}
      </div>
    </Section>;
}